import moment from "moment";
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { GetOrder, GetOrders, get_orders } from "../../actions/orders";
import Table from "../../common/Table";
import { NavWrap, TableWrap } from "../ShopForTyres";
import { useFormik } from "formik";
import "../styles/order.css";
import json2csv from "json2csv";
import { saveAs } from "file-saver";
import { DownloadOutlined } from "@ant-design/icons";
import { DatePicker, Modal, Select } from "antd";
import { get_customers } from "../../actions/admin/Action";
import * as Yup from "yup";
import { toast } from "react-toastify";

const OrdersSchema = Yup.object().shape({
  customer_name: Yup.string().required("Customer is required."),
  start_date: Yup.string().nullable(true),
  end_date: Yup.string().when("start_date", {
    is: (val) => val,
    then: Yup.string().nullable(true).required("End Date is required."),
    otherwise: Yup.string().nullable(true),
  }),
});
const Orders = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [scModel, setscModel] = useState(false);
  const orders = useSelector((state) => state?.orders?.all);
  const [dates, setDates] = useState({});
  const [ordersList, setOrdersList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({});
  const [custs, setCusts] = useState([]);
  const location = useLocation();
  const customers = useSelector((state) => state?.admin?.customers?.data);
  const [tableScroll, setTableScroll] = useState({ x: "100%" });

  useEffect(() => {
    const screenWidth = window.screen.width;
    const newScroll = screenWidth > 2000 ? { x: "100%" } : { x: 2000 };
    setTableScroll(newScroll);
  }, []);
  const formik = useFormik({
    initialValues: {
      customer_name: "",
      start_date: null,
      end_date: null,
    },
    onSubmit: (vals) => {
      dispatch({
        type: GetOrders.RESET,
      });
      setOrdersList([]);
      dispatch(
        get_orders({
          email: localStorage.getItem("email"),
          ...vals,
          per_page: 30,
          page: 1,
        })
      );
      setFilters({
        ...filters,
        customer_name: vals.customer_name,
      });
      let obj = {
        ...vals,
      };
      delete obj.customer_name;
      setDates({
        ...obj,
      });
      setscModel(false);
    },
    validationSchema: OrdersSchema,
  });
  useEffect(() => {
    dispatch(
      get_customers({
        email: localStorage.getItem("email"),
      })
    );
    return () => {
      dispatch({
        type: GetOrders.RESET,
      });
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (!filters?.customer_name) setscModel(true);
      else if (scModel) {
        setscModel(false);
      }
    }, 500);
    // eslint-disable-next-line
  }, [filters?.customer_name]);

  useEffect(() => {
    if (location?.state?.filters) {
      dispatch(
        get_orders({
          email: localStorage.getItem("email"),
          ...location?.state?.filters,
          per_page: 30,
          page: 1,
        })
      );
      setFilters(location?.state?.filters);
    }
  }, [location?.state]);

  useEffect(() => {
    if (customers?.length > 0) {
      setCusts(
        customers
          ?.filter((ele) => ele.status === "active")
          ?.map((ele) => ({ label: ele.name, value: ele.sap_id }))
      );
    }
    // eslint-disable-next-line
  }, [customers]);

  const sync = (resetSearch, dates) => {
    let fils = { ...filters };
    if (resetSearch) {
      setFilters((f) => ({ ...f, search: "" }));
      fils.search = "";
    }
    if (location?.state?.filters) {
      setFilters(fils);
      history.replace("/admin/orders");
    }

    if (dates.start_date && dates.end_date) {
      dispatch(
        get_orders({
          email: localStorage.getItem("email"),
          ...dates,
          ...fils,
          per_page: 30,
          page,
        })
      );
    } else {
      if (!dates.start_date && !dates.end_date) {
        dispatch(
          get_orders({
            email: localStorage.getItem("email"),
            ...fils,
            per_page: 30,
            page,
          })
        );
      }
    }
  };

  const columns = [
    {
      header: "Order Date",
      accessor: "date",
      width: 10,
      cell: (row) => (
        <span>
          {moment(row?.order_sales_nav?.QuotationDate, "YYYYMMDD").format(
            "DD/MM/YYYY"
          )}
        </span>
      ),
    },
    {
      header: "Customer Name",
      accessor: "name",
      width: 10,
      cell: (row) => <span>{row?.order_sales_nav?.Name1}</span>,
    },
    {
      header: "Temporary Order Number",
      accessor: "order_number",
      width: 10,
      cell: (row) => (
        <span
          className="error-text cursor"
          // onClick={(e) => {
          //   e.stopPropagation();
          //   history.push("/admin/order-detail");
          // }}
        >
          {row.order_number}
        </span>
      ),
    },
    {
      header: "Order Type",
      accessor: "order_type",
      width: 10,
      cell: (row) => (
        <span style={{ textTransform: "uppercase" }}>{row.order_type}</span>
      ),
    },
    {
      header: "SO Number",
      accessor: "so_number",
      width: 10,
      cell: (row) => (
        <span className="error-text">
          {row.so_number ? row.so_number : "-"}
        </span>
      ),
    },
    {
      header: "PO Number",
      accessor: "po_number",
      width: 15,
      cell: (row) => <span className="error-text">{row.po_number}</span>,
    },
    {
      header: "Quantity Ordered",
      accessor: "total_quantity",
      width: 10,
    },
    {
      header: "Delivery Address",
      accessor: "delivery_address",
      width: 15,
      cell: (row) =>
        typeof row?.delivery_address === "string" ? (
          <span>{row?.delivery_address}</span>
        ) : row?.order_sales_nav?.Street ? (
          <span>
            {row?.order_sales_nav?.Street}
            {row?.order_sales_nav?.Street && ", "}
            {row?.order_sales_nav?.City1}
            {row?.order_sales_nav?.City1 && ", "}
            {row?.order_sales_nav?.Country}
            {row?.order_sales_nav?.Country && ", "}
            {row?.order_sales_nav?.PostCode1}
          </span>
        ) : (
          <span>
            {row?.delivery_address?.address1}
            {row?.delivery_address?.address1 && ", "}
            {row?.delivery_address?.address2}
            {row?.delivery_address?.address2 && ", "}
            {row?.delivery_address?.city}
            {", "}
            {row?.delivery_address?.zip}
          </span>
        ),
    },
    // {
    //   header: "PI Status",
    //   accessor: "pi_status",
    //   width: 14,
    //   cell: (row) => <span className="text-btn">{row.pi_status}</span>,
    //   className: "pi_status",
    // },
    {
      header: "Order Status",
      accessor: "order_status",
      width: 10,
      cell: (row) => (
        <span className="success-text">
          {row?.cancelled_order ? "Cancelled" : row.order_status}
        </span>
      ),
    },
  ];

  useEffect(() => {
    if (ordersList.length && page > 1) {
      sync(true, {});
    }
    // eslint-disable-next-line
  }, [page]);

  useEffect(() => {
    if (Array.isArray(orders?.data?.orders?.orders) && page === 1) {
      setOrdersList(orders?.data?.orders?.orders);
      setTotalRecords(0);
    }
    // eslint-disable-next-line
  }, [orders]);

  const resetOrders = () => {
    setOrdersList([]);
    setTotalRecords(0);
    setPage(1);
    dispatch({
      type: GetOrders.RESET,
    });
  };

  return (
    <div className="showTyresFilters">
      <Modal
        title="Select Filters"
        visible={scModel && !filters?.customer_name}
        closable={false}
        footer={null}
      >
        <form className="marketing-form" onSubmit={formik.handleSubmit}>
          <div className="mb1">
            <label>Select Customer Name *</label>
            <Select
              className="w100"
              options={custs}
              placeholder={"Select Customer Name"}
              onChange={(val) => {
                formik.setFieldValue("customer_name", val);
              }}
            />
            {formik?.errors?.customer_name &&
              formik?.touched?.customer_name && (
                <div className="error-text mtHalf">
                  {formik?.errors?.customer_name}
                </div>
              )}
          </div>
          <div className="mb1">
            <label>Start Date</label>
            <DatePicker
              className="w100"
              format={"DD-MM-YYYY"}
              value={formik.values.start_date}
              onChange={(vals) => {
                formik.setFieldValue("start_date", vals);
              }}
              placeholder={"Select Start Date"}
            />
            {formik?.errors?.start_date && formik?.touched?.start_date && (
              <div className="error-text mtHalf">
                {formik?.errors?.start_date}
              </div>
            )}
          </div>
          <div className="mb1">
            <label>End Date</label>
            <DatePicker
              className="w100"
              format={"DD-MM-YYYY"}
              value={formik.values.end_date}
              onChange={(vals) => {
                formik.setFieldValue("end_date", vals);
              }}
              placeholder={"Select End Date"}
            />
            {formik?.errors?.end_date && formik?.touched?.end_date && (
              <div className="error-text mtHalf">
                {formik?.errors?.end_date}
              </div>
            )}
          </div>

          <div>
            <button
              className="cancel-btn mr1"
              type="button"
              onClick={() => {
                if (formik?.values?.customer_name) setscModel(false);
                else toast.error("Please select customer");
              }}
            >
              {"Close"}
            </button>
            <button className="primary-btn" type="submit">
              Ok
            </button>
          </div>
        </form>
      </Modal>
      <NavWrap>
        <TableWrap
          isFilter={false}
          showBulk={false}
          setFilters={setFilters}
          name={
            <span>
              {`All Orders ${
                ordersList?.length ? `(${ordersList?.length})` : ""
              }`}
            </span>
          }
          showGrid={false}
          searchPlaceholder={"Search by temporary order number..."}
          namedFilters={[
            {
              label: `All`,
              action: () => {
                resetOrders();
                let obj = {
                  ...filters,
                  email: localStorage.getItem("email"),
                  filter: "",
                };
                if (dates.end_date && dates.start_date) {
                  dispatch(
                    get_orders({ ...obj, ...dates, page: 1, per_page: 30 })
                  );
                } else {
                  dispatch(get_orders({ ...obj, page: 1, per_page: 30 }));
                }
                setFilters((f) => ({ ...f, filter: "" }));
              },
              isActive: filters.filter === undefined,
            },
            {
              label: "Awaiting Approval",
              action: () => {
                resetOrders();
                let obj = {
                  email: localStorage.getItem("email"),
                };
                if (dates.end_date && dates.start_date) {
                  dispatch(
                    get_orders({
                      ...obj,
                      ...dates,
                      ...filters,
                      filter: "B",
                      page: 1,
                      per_page: 30,
                    })
                  );
                } else {
                  dispatch(
                    get_orders({
                      ...obj,
                      ...filters,
                      filter: "B",
                      page: 1,
                      per_page: 30,
                    })
                  );
                }
                setFilters((f) => ({
                  ...f,
                  filter: "B",
                }));
              },
              isActive: filters.filter === "B",
            },
            {
              label: "Confirmed",
              action: () => {
                resetOrders();
                let obj = {
                  email: localStorage.getItem("email"),
                };
                if (dates.end_date && dates.start_date) {
                  dispatch(
                    get_orders({
                      ...obj,
                      ...dates,
                      ...filters,
                      filter: "A",
                      page: 1,
                      per_page: 30,
                    })
                  );
                } else {
                  dispatch(
                    get_orders({
                      ...obj,
                      ...filters,
                      filter: "A",
                      page: 1,
                      per_page: 30,
                    })
                  );
                }
                setFilters((f) => ({ ...f, filter: "A" }));
              },
              isActive: filters.filter === "A",
            },
            {
              label: "Completed",
              action: () => {
                resetOrders();
                let obj = {
                  email: localStorage.getItem("email"),
                };
                if (dates.end_date && dates.start_date) {
                  dispatch(
                    get_orders({
                      ...obj,
                      ...dates,
                      ...filters,
                      filter: "C",
                      page: 1,
                      per_page: 30,
                    })
                  );
                } else {
                  dispatch(
                    get_orders({
                      ...obj,
                      ...filters,
                      filter: "C",
                      page: 1,
                      per_page: 30,
                    })
                  );
                }
                setFilters((f) => ({ ...f, filter: "C" }));
              },
              isActive: filters.filter === "C",
            },
            {
              label: "Cancelled",
              action: () => {
                resetOrders();
                let obj = {
                  email: localStorage.getItem("email"),
                };
                if (dates.end_date && dates.start_date) {
                  dispatch(
                    get_orders({
                      ...obj,
                      ...dates,
                      ...filters,
                      filter: "X",
                      page: 1,
                      per_page: 30,
                    })
                  );
                } else {
                  dispatch(
                    get_orders({
                      ...obj,
                      ...filters,
                      filter: "X",
                      page: 1,
                      per_page: 30,
                    })
                  );
                }
                setFilters((f) => ({ ...f, filter: "X" }));
              },
              isActive: filters.filter === "X",
            },
          ]}
          selectPlaceHolder={"Select By Customer name"}
          value={filters.customer_name}
          onSelect={(val) => {
            resetOrders();
            setFilters((f) => ({
              ...f,
              customer_name: val,
            }));
            if (val)
              dispatch(
                get_orders({
                  email: localStorage.getItem("email"),
                  ...filters,
                  ...dates,
                  customer_name: val,
                  page: 1,
                  per_page: 30,
                })
              );
            else {
              dispatch({ type: GetOrders.RESET });
            }
          }}
          exportComponent={
            <button
              disabled={
                orders?.loading || !orders?.data?.orders?.orders?.length
              }
              onClick={() => {
                let prods = ordersList?.map((ele) => ({
                  "Order date": moment(
                    ele?.order_sales_nav?.QuotationDate,
                    "YYYYMMDD"
                  ).format("DD/MM/YYYY"),
                  "Temporary Order Number": ele.order_number?.toString(),
                  "Order Type": ele.order_type,
                  "SO Number": ele.so_number,
                  "PO Number": ele?.order_sales_nav?.Bstnk
                    ? ele?.order_sales_nav?.Bstnk
                    : ele.po_number,
                  "Quantity Ordered": ele.total_quantity,
                  "Delivery Address": `${
                    typeof ele?.delivery_address === "string"
                      ? ele?.delivery_address
                      : `
                      ${
                        ele?.order_sales_nav?.Street
                          ? ele?.order_sales_nav?.Street + ", "
                          : ""
                      }
                      ${
                        ele?.order_sales_nav?.City1
                          ? ele?.order_sales_nav?.City1 + ", "
                          : ""
                      }
                      ${
                        ele?.order_sales_nav?.Country
                          ? ele?.order_sales_nav?.Country + ", "
                          : ""
                      }
                      ${
                        ele?.order_sales_nav?.PostCode1
                          ? ele?.order_sales_nav?.PostCode1
                          : ""
                      }
                    `
                  }`,
                  "Order Status": ele.order_status,
                }));
                let csv = json2csv.parse(prods);
                var blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
                saveAs(blob, "OrdersHistory.csv");
              }}
            >
              <DownloadOutlined color="#333" />
            </button>
          }
          searchVal={filters.search}
          isDateFilter={true}
          dates={dates}
          isRange={true}
          isSync={true}
          selectBox={true}
          options={custs}
          sync={() => {
            resetOrders();
            sync(true, {});
            setDates({});
          }}
          onRangeChange={(val) => {
            let start_date = val?.[0] ? moment(val?.[0]) : null;
            let end_date = val?.[1] ? moment(val?.[1]) : null;
            if (val === null) {
              setDates({});
              if (filters.customer_name) {
                resetOrders();
                sync(false, {
                  ...filters,
                });
              }
            } else {
              if (start_date && end_date) {
                if (filters.customer_name) {
                  resetOrders();
                  sync(false, {
                    start_date,
                    end_date,
                    ...filters,
                  });
                }
                setDates({
                  start_date,
                  end_date,
                });
              }
            }
          }}
          callSearch={(search) => {
            let obj = {
              email: localStorage.getItem("email"),
            };
            resetOrders();
            if (dates.end_date && dates.start_date) {
              dispatch(
                get_orders({
                  ...obj,
                  ...dates,
                  ...filters,
                  search,
                  per_page: 30,
                  page: 1,
                })
              );
            } else {
              dispatch(
                get_orders({
                  ...obj,
                  ...filters,
                  search,
                  per_page: 30,
                  page: 1,
                })
              );
            }
            setFilters((f) => ({ ...f, search }));
          }}
        >
          <Table
            columns={columns}
            data={ordersList}
            noDataMsg={
              filters.customer_name ? "" : "Please select the customer."
            }
            action={false}
            actionWidth={8}
            scroll={tableScroll}
            totalRecords={totalRecords}
            lazy={true}
            isLastPage={
              ordersList?.length > 0 && ordersList?.length < totalRecords
            }
            onPagination={() => {
              setPage((p) => p + 1);
            }}
            loading={orders?.loading}
            onRowClick={(val) => {
              if (val.order_number?.startsWith("22"))
                history.push("/admin/order-detail", {
                  order_id: val.order_number,
                  customer_number: val.customer_number,
                  order_number: val.order_number,
                  filters: filters,
                });
              else {
                dispatch({
                  type: GetOrder.SUCCESS,
                  payload: {
                    order: { ...val },
                  },
                });
                history.push("/admin/order-detail", {
                  order: val,
                  order_number: val.order_number,
                  filters: filters,
                });
              }
            }}
          />
        </TableWrap>
      </NavWrap>
    </div>
  );
};

export default Orders;
